import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PhoneMismatchAllowlistService {
  constructor(private http: HttpClient) {}

  list(search?: string) {
    let params = new HttpParams();
    if (search?.trim()) params = params.set('search', search.trim());
    return this.http.get<any[]>(`${environment.url}/phone-mismatch-allowlist`, { params });
  }

  create(companyId: string, phone: string) {
    return this.http.post(`${environment.url}/phone-mismatch-allowlist`, { companyId, phone });
  }

  update(id: string, body: { companyId?: string; phone?: string }) {
    return this.http.put(`${environment.url}/phone-mismatch-allowlist/${id}`, body);
  }

  remove(id: string) {
    return this.http.delete(`${environment.url}/phone-mismatch-allowlist/${id}`);
  }
}
